import React from "react";
import { Box, Alert } from "@mui/material";
import UserGroupsTable from "../tables/userGroupsTable";
import UserTable from "../tables/usersTable";
import ShiftTable from "../tables/shiftTable";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTab } from "state/tabSlice";
import CustomTab from "components/Tabs/Tab";

const UserMangementTab = () => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(useSelector((state)=> state.tabReducer.currentTab['userMangementTab']) );
  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(setCurrentTab({ name: "userMangementTab", tab: newValue })); 
  };
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [isFailed, setIsFailed]  = React.useState(false);

  const tabComponents = [
    {Component: <UserTable setIsSuccess={setIsSuccess} setIsFailed={setIsFailed} />, label: "USERS", "index": 0 },
    {Component: <UserGroupsTable setIsSuccess={setIsSuccess}/>, label: "USER GROUPS", "index": 1},
    {Component: <ShiftTable setIsSuccess={setIsSuccess}/>, label: "SHIFTS", "index": 2},
  ] 

  React.useEffect(() =>{
    const timer = setTimeout(() => {
      setIsSuccess(false)
      setIsFailed(false)
    }, 3000);
    return () => clearTimeout(timer);
  }, [isSuccess, isFailed]);


  return (
    <Box>
      {isSuccess ? (
        <Alert sx={{ m: "15px" }} variant="filled" severity="success">Operation was successful!</Alert>
      ) : isFailed ? (
        <Alert sx={{ m: "15px" }} variant="filled" severity="error">Operation was not successful!</Alert>
      ) : null}

      <CustomTab tabComponents={tabComponents} value={value} handleChange={handleChange}/> 
    </Box>
  );
};

export default UserMangementTab;